import * as React from "react";
import { SVGProps } from "react";
const SvgHomeGreen = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#home-green_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m31.9 15.56-5.83-12a1 1 0 0 0-.9-.56H6.83a1 1 0 0 0-.9.56l-5.83 12A1 1 0 0 0 1 17h4v10a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V17h4a1 1 0 0 0 .9-1.44ZM25 17v9H7V15H2.6L7.46 5h17.08l4.86 10H25v2Zm-4.083-8.023-.159-1.325-1.227.525c-2.327 1-5.01 2.26-6.557 4.072a5.133 5.133 0 0 0-1.332 3.413 6.7 6.7 0 0 0 1.249 3.615l-1.685 2.917a1 1 0 1 0 1.732 1l1.685-2.917a6.7 6.7 0 0 0 3.755-.727 5.135 5.135 0 0 0 2.29-2.859c.796-2.246.55-5.202.249-7.714Zm-3.856 7.078-1.279 2.214a3.93 3.93 0 0 0 1.608-.457 3.147 3.147 0 0 0 1.393-1.79c.467-1.78.567-3.638.294-5.458a13.548 13.548 0 0 0-4.577 2.984 3.14 3.14 0 0 0-.854 2.1c.018.563.157 1.116.408 1.621l1.278-2.214a1 1 0 1 1 1.733 1h-.004Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="home-green_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHomeGreen;
